import "./styles.less";

import * as React from "react";

import { Button, Space } from "antd";
import { MouseEvent, useContext, useEffect, useRef, useState } from "react";
import { OwnerPhoneInterface, usePhoneButton } from "./hook";

import { ModalPhone } from "../../../ModalPhone/web";
import { PhoneOutlined, PhoneFilled } from "@ant-design/icons";
import { useFacebookPixel } from "../../../../../GlobalHooks/web/FacebookPixel.hook";
import { useTheme } from "../../../../../Styles/ThemeHook";
import Text from "antd/lib/typography/Text";
import { ConfigStateContext } from "../../../../../Contexts/Configurations/context";
import { ModalState } from "../../TextForm/type";
import { UserStateContext } from "shared-components/Contexts/User/context";
import dynamic from "next/dynamic";
import Mandatory from "shared-components/Components/User/Mandatory/web";
import { useUser } from "shared-components/Components/User/User.hook";
import { CountryCode } from "libphonenumber-js";

const Modal = dynamic(
	() => import("shared-components/Components/Modal/web").then(mod => mod.Modal),
	{ ssr: false }
);

export const getInitialContactForm = () => {
	const contactForm = localStorage.getItem("contactForm");
	if (contactForm) {
		const formParsed = JSON.parse(contactForm);
		return {
			name: formParsed.name,
			phone: formParsed.phone,
			email: formParsed.email,
			fincatyc: false,
		};
	}

	return {
		name: "",
		phone: "",
		email: "",
		fincatyc: false,
	};
};

export const getInitCountryCode = () => {
	const countryCode = localStorage.getItem("selectedCountryCode");
	return countryCode ? JSON.parse(countryCode) : { code: "CO", value: "+57" };
};

export const PhoneButton = ({
	id,
	type = "callButton",
	mode,
	disabled = false,
	seller = false,
	queryRouter,
	icon = false,
	btnType = "default",
	onPhoneClick,
	forceState = ModalState.DEFAULT,
	owner,
	isProject = false,
	dataModal = {
		name: "",
		phone: "",
		email: "",
		fincatyc: false,
	},
	setDataModal,
	hasAcceptedTerms = true,
	onTermsError
}: OwnerPhoneInterface) => {
	const FP = useFacebookPixel();
	const { theme } = useTheme();
	const callPhone = useRef(null);
	const { country_code } = useContext(ConfigStateContext);

	if (!owner || !owner?.masked_phone) return null;

	const [selectedCountryCode, setSelectedCountryCode] = useState<{
		code: CountryCode;
		value: string;
	}>({
		// This code should be a setting, depending the website
		code: "CO",
		value: "+57",
	});

	const { viewPhone, phone, loading, userExistsQuery } = usePhoneButton({
		property_id: id,
		seller,
		isProject,
		email: dataModal?.email,
		phone: selectedCountryCode.value + dataModal?.phone,
		name: dataModal?.name,
	});

	const [modal, setModal] = useState(false);
	const [openDataModal, setOpenDataModal] = useState(false);
	const [phoneData, setPhoneData] = useState(null);
	const [sentLead, setSentLead] = useState(false);

	useEffect(() => {
		if (forceState == ModalState.CLOSE) {
			setModal(false);
		} else if (forceState == ModalState.OPEN) {
			setModal(true);
		}
	}, [forceState]);

	// Simula el click de ver "Telefono"
	useEffect(() => {
		setTimeout(() => {
			if (queryRouter && queryRouter === "call") {
				if (callPhone.current) callPhone.current.click();
			}
		}, 3000);
	}, [queryRouter]);

	const makePhoneCall = phoneNumber => {
		if (phoneNumber) {
			window.location.href = `tel:${phoneNumber}`;
			return true;
		}
		return false;
	};

	const sendEvent = () => {
		const categoryName: string = "Consultas Tel";
		FP.StandardEvent(categoryName);
	};

	const handleClick = async (e: MouseEvent) => {
		e.preventDefault();
		e.stopPropagation();

		if (dataModal?.email) {
			userExistsQuery({ variables: { email: dataModal?.email } });
		}

		if (phoneData) {
			sendEvent();
			makePhoneCall(phoneData.data.requestPhoneAgent[0]?.phone);
			setModal(true);
			setOpenDataModal(false);
		} else {
			await viewPhone().then(data => {
				if (data) {
					sendEvent();
					makePhoneCall(data?.data?.requestPhoneAgent[0]?.phone);
					setPhoneData(data);
					setModal(true);
					setOpenDataModal(false);
					setSentLead(true);
				}
			});
		}
	};

	const {
		isLoggedIn,
		user: { refetch },
	} = useUser();
	const [userHasAllData, setUserHasAllData] = useState(false);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const user = useContext(UserStateContext);

	useEffect(() => {
		if (country_code !== "CO") {
			setUserHasAllData(true);
		}
		if (country_code === "CO" && user.me) {
			const hasAllData = !!user.me.phone && !!user.me.name;
			setUserHasAllData(hasAllData);
		}
	}, [user.me]);

	const viewPhoneBtn = (
		<Space size={4} className="view-phone-btn">
			{icon && <PhoneFilled />}
			<Text className="masked">{owner?.masked_phone}</Text>
			{owner?.masked_phone && (
				<Button
					ref={callPhone}
					loading={loading}
					onClick={(e: any) => {
						if (userHasAllData || !isLoggedIn) {
							if (!isLoggedIn) {
								setOpenDataModal(true);
							} else {
								handleClick(e);
							}
						} else {
							setIsModalVisible(true);
						}
					}}
					className="secondary"
					type={btnType}
					disabled={disabled}>
					{"Ver teléfono"}
				</Button>
			)}
		</Space>
	);

	const callBtn = (
		<Button
			ref={callPhone}
			className="phone-button"
			loading={loading}
			onClick={e => {
				if (hasAcceptedTerms) {
					if (userHasAllData || !isLoggedIn) {
						setOpenDataModal(true);
						handleClick(e);
					} else {
						setIsModalVisible(true);
					}
				} else {
					if (onTermsError) onTermsError();
				}
			}}
			style={{ borderColor: !disabled ? theme.colors.linkColor : "" }}
			icon={
				country_code === "ce3" ? (
					<PhoneFilled style={{ color: "#FFF" }} />
				) : (
					<PhoneOutlined style={{ color: disabled ? "rgba(0, 0, 0, .25)" : "#FFF" }} />
				)
			}
			disabled={disabled}>
			Llamar
		</Button>
	);

	return (
		<>
			<Modal show={isModalVisible} onClose={() => setIsModalVisible(false)} height="500px">
				<div className="auth-modal-wrapper">
					<div className="auth-modal">
						<Mandatory
							onOk={(e: any) => {
								handleClick(e);
								setIsModalVisible(false);
								setUserHasAllData(true);
								refetch();
							}}
							user={user}
						/>
					</div>
				</div>
			</Modal>
			{type == "callButton" ? callBtn : viewPhoneBtn}
			<ModalPhone
				visible={modal}
				loading={loading}
				onCancel={() => setModal(false)}
				property_id={id}
				owner_name={owner.name}
				phone={phone}
				mode={mode}
				onClick={onPhoneClick}
			/>
		</>
	);
};

